<template>
    <b-card no-body>
        <v-table ref="table" 
            :items-provider="provider" 
            :fields="fields" 
            pagination="server" 
            :settings="false" 
            search 
            :buttons="buttons" 
            v-on:fetch-result-raw="onFetch">
            <template #additional-actions>
                <div class="row">
                    <div class="col-md-auto mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="branchType">
                            <option value="O">Org. Şube</option>
                            <option value="S">SGK Şube</option>
                        </select>
                    </div>
                    <div class="col-md-3 mb-1 mb-md-0" v-if="branchType == 'O'">
                        <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
                    </div>
                    <div class="col-md-3 mb-1 mb-md-0" v-if="branchType == 'S'">
                        <v-select-list :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
                    </div>
                    <div class="col-md-3 mb-1 mb-md-0">
                        <v-select-list :options="statuses" label="name" v-model="status" placeholder="Kritiklik Seviyesi"></v-select-list>
                    </div>
                    <div class="col-md-2">
                        <select class="form-control bg-img-none" v-model="jobExit">
                            <option :value="null">Tümü</option>
                            <option :value="false">Çalışıyor</option>
                            <option :value="true">Ayrıldı</option>
                        </select>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-success" v-on:click="$refs.table.refresh()">Sorgula</button>
                    </div>
                    <div class="col-auto" v-if="excelPath">
                        <button class="btn btn-outline-success" v-on:click="downloadExcel">Excel</button>
                    </div>
                </div>
            </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from "bootstrap-vue";
import DigitalDriverLicenseApi from "@/api/digital-driver-license";
import moment from "moment";
import CompanyApi from "@/api/company";
import SystemDataApi from "@/api/system-data";
import Additional from "@/utilities/additional";

export default {
    components: {
        BCard,
    },
    data() {
        return {
            fields: [
                { tdClass: "text-nowrap", name: "Personel", key: "EmployeeFullName", thClass: "w-14" },
                { tdClass: "text-nowrap", name: "SGK Şube", key: "SGKBranchName", thClass: "w-12" },
                { tdClass: "text-nowrap", name: "Unvan", key: "EmployeeDepartmentTitleName", thClass: "w-14" },
                { tdClass: "text-nowrap", name: "Meslek Kodu", key: "OccupationTitleCode", thClass: "w-12" },
                { tdClass: "text-nowrap", name: "Meslek Adı", key: "OccupationTitleName", thClass: "w-12" },
                { tdClass: "text-nowrap", name: "Başlangıç Tarihi", key: "StartDateStr", thClass: "w-12" },
                { tdClass: "text-nowrap", name: "Bitiş Tarihi", key: "EndDateStr", thClass: "w-12" },
                { tdClass: "text-nowrap", name: "Kalan Gün", key: "RemainingDate", thClass: "w-12" },
                { tdClass: "text-nowrap", name: "Kritiklik Seviyesi", component: true, componentOptions: { name: "employee-report-status/EmployeeReportStatus" } },
            ],
            buttons: [],
            branches: [],
            sbranches: [],
            collarStatuses: [],
            branchType: "O",
            branch: null,
            sbranch: null,
            collarStatus: null,
            excelPath: null,
            jobExit: null,
            statuses: [
                { name: "Devam Ediyor", key: "DE" },
                { name: "Yaklaşıyor", key: "Y" },
                { name: "Dolmak Üzere", key: "DU" },
                { name: "Bitti", key: "B" },
            ],
            status: null,
        };
    },
    mounted() {
        this.getSBranches();
        this.getBranches();
        this.getCollarStatuses();
    },
    methods: {
        onFetch(e) {
            this.excelPath = e.data.ExcelPath;
        },
        provider(data) {
            return DigitalDriverLicenseApi.DigitalDriverLicenseReport({
                PaginateRequest: data,
                Month: moment().month() + 1,
                Year: moment().year(),
                JobExit: this.jobExit,
                BranchId: this.branchType == "O" ? this.branch?.Id || null : this.sbranch?.Id || null,
                BranchTypeCode: this.branchType,
                Status: this.status?.key || null,
            });
        },
        getBranches() {
            CompanyApi.Branch.ListByCode("O").then((res) => {
                this.branches = res.data.Data;
            });
        },
        getSBranches() {
            CompanyApi.Branch.ListByCode("S").then((res) => {
                this.sbranches = res.data.Data;
            });
        },
        getCollarStatuses() {
            SystemDataApi.CollarStatus().then((res) => {
                this.collarStatuses = res.data.Data;
            });
        },
        downloadExcel() {
            if (this.excelPath) {
                Additional.DownloadTab(this.excelPath);
            }
        },
    },
};
</script>
